export enum SafelinksPolicyRefreshStatus {
    NotStarted,
    InProgress,
    Completed,
    Failed,
    NotSupported,
    NotNeeded,
}
